import { useLocation } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';


const PageBreadCrumbs = (): JSX.Element => {

  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(Boolean);  // Splitting the path by "/" and removing empty segments

  const separateCamelCaseTitle = (str: string) => {
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
  };

  return (
    <Stack spacing={2}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        <Link underline="none" fontSize={"small"} color="inherit" href="/">
          Home
        </Link>
        {
          pathnames.map((value, index) => {
            const last = index === pathnames.length - 1;
            const link = `/${pathnames.slice(0, index + 1).join('/')}`;
            const title = separateCamelCaseTitle(value);

            return last ? (
              <Typography key={index} fontSize={"small"} color="primary">
                {title}
              </Typography>
            ) : (
              <Link underline="none" fontSize={"small"} key={index} color="inherit" href={link}>
                {title}
              </Link>
            );
          })
        }
      </Breadcrumbs>
    </Stack>
  );
}

export default PageBreadCrumbs;